import React from 'react';
import {
  Create,
  Edit,
  ReferenceField,
  Show,
  ShowButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
} from 'react-admin';
import AutocompleteStudioInput from './components/AutocompleteStudioInput';
import ClipboardField from './components/ClipboardField';
import InfiniteList from './components/InfiniteList';
import { WriteOnlyDatagrid } from './components/WriteOnlyDatagrid';
import { WriteOnlyEditButton } from './components/WriteOnlyEditButton';

export const MboContractMappingList: React.FC = () => (
  <InfiniteList>
    <WriteOnlyDatagrid bulkActionButtons={false}>
      <ClipboardField source="id" sortable={false} />
      <ReferenceField source="studio.id" reference="Studio" label="Studio">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="employeeType" label="Employee Type" sortable={false} />
      <TextField
        source="mboServiceId"
        label="MBO Service ID"
        sortable={false}
      />
      <WriteOnlyEditButton />
      <ShowButton />
    </WriteOnlyDatagrid>
  </InfiniteList>
);

export const MboContractMappingShow: React.FC = () => (
  <Show>
    <SimpleShowLayout>
      <ClipboardField source="id" label="ID" fontSize={14} />
      <ReferenceField source="studio.id" reference="Studio" label="Studio">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="mboServiceId" label="MBO Service ID" />
      <TextField source="employeeType" label="Employee Type" />
    </SimpleShowLayout>
  </Show>
);

export const MboContractMappingEdit: React.FC = () => (
  <Edit mutationMode="pessimistic" redirect={false}>
    <SimpleForm>
      <AutocompleteStudioInput source="studio.id" label="Studio" isRequired />
      <TextInput source="mboServiceId" label="MBO Service ID" />
      <TextInput source="employeeType" label="Employee Type" />
    </SimpleForm>
  </Edit>
);

export const MboContractMappingCreate: React.FC = () => (
  <Create>
    <SimpleForm>
      <AutocompleteStudioInput source="studio.id" label="Studio" isRequired />
      <TextInput source="mboServiceId" label="MBO Service ID" />
      <TextInput source="employeeType" label="Employee Type" />
    </SimpleForm>
  </Create>
);
